import * as React from 'react';
import { NavbarDropdownMenuFieldsFragment, NavbarFieldsFragment, ItemsList } from 'types/generated';
import NavbarChild from './NavbarChild';
import NavbarDropdownMenu from './NavbarDropdownMenu';
import { motion } from 'framer-motion';
import NavbarDropdownList from './NavbarDropdownList';
import { bezierEase } from '@/utils/utils';

type Props = {
  ref: React.RefObject<HTMLDivElement | null>;
  data: NavbarFieldsFragment;
  activeDropdown: NavbarDropdownMenuFieldsFragment | undefined;
  openDropdownTitle: string | null | undefined;
  setOpenDropdownTitle: (title: string | null | undefined) => void;
};

const MobileNavLinks = ({ ref, data, activeDropdown, openDropdownTitle, setOpenDropdownTitle }: Props) => {
  const [isOpenList, setIsOpenList] = React.useState<boolean>(false);

  const itemList = data.childrenCollection?.items?.find((item) => item?.__typename === 'ItemsList') as ItemsList;

  return (
    <motion.div
      className="self-stretch"
      initial={activeDropdown || isOpenList ? {} : { height: 0 }}
      animate={activeDropdown || isOpenList ? {} : { height: 'auto' }}
      exit={activeDropdown || isOpenList ? {} : { height: 0 }}
    >
      {!activeDropdown && !isOpenList && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.12, ease: bezierEase } }}
          className="flex flex-col items-start justify-center gap-xs self-stretch p-0"
        >
          {data.childrenCollection?.items?.map((child, index) => (
            <NavbarChild
              key={index}
              childData={child as ItemsList}
              openDropdownTitle={openDropdownTitle}
              setOpenDropdownTitle={setOpenDropdownTitle}
              setOpenList={setIsOpenList}
              showMobileMenu={true}
            />
          ))}
        </motion.div>
      )}
      {activeDropdown && (
        <div ref={ref} className="h-full self-stretch">
          <NavbarDropdownMenu
            data={activeDropdown}
            setOpenDropdownTitle={setOpenDropdownTitle}
            openDropdownTitle={openDropdownTitle}
            showMobileMenu={true}
          />
        </div>
      )}
      {isOpenList && (
        <div className="flex flex-col items-start justify-center gap-xs self-stretch p-0">
          <NavbarDropdownList
            isOpen={isOpenList}
            data={itemList}
            showMobileMenu={true}
            setOpenDropdownTitle={setOpenDropdownTitle}
            openDropdownTitle={openDropdownTitle}
            setOpenList={setIsOpenList}
          />
        </div>
      )}
    </motion.div>
  );
};

export default MobileNavLinks;
